import { LoginFormComponent } from './../../login-form/login-form.component';
import { ModalLoginInfo, ModalLoginMessage } from './../../../types/modal-login-message';
import { Component, OnInit, ElementRef, ViewChild, OnDestroy, HostListener } from '@angular/core';
import { NgbModal, NgbModalRef, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalMessagerService } from './modal-messager.service';
import { ModalConfirmMsg } from 'app/types/modalconfirmmsg';
import { ModalMessage } from 'app/types/modalmessage';
import { ModalProgMsg } from 'app/types/modalprogmsg';
import { ModalNotice } from 'app/types/modalnotice';
import { InterruptableTimer } from 'app/model/interruptable-timer';
import { SubscriptionMgr } from 'app/model/SubscriptionMgr';
import { StatefulCSS } from 'app/model/stateful_css';
import { ModalFileRequestMessage } from 'app/types/modalfilerequestmessage';
import { ModaLRemoteCtrlMessage } from 'app/types/modall-remote-ctrl-message';
import { ModalFileDownloadRequestMessage } from 'app/types/modal-file-download-request';
import { ServerService } from 'app/model/services/api-services/server.service';
import { DictHandler, SimpleHandler } from 'app/types/handlers';
import { Dict } from 'app/types/decorable';


enum ModalMessagerMode {
  UNKNOWN = '',
  CONFIRM = 'confirm',
  NOTIFY = 'notify',
  PROGRESS = 'progress',
  REQ_IMPORT = 'request-import',
  REQ_EXPORT = 'request-export',
  REQ_DOWNLOAD = 'request-download',
  LOGIN = 'login'
}

@Component({
  selector: 'app-modal-messager-content',
  templateUrl: './modal-messager.component.html',
  styleUrls: ['./modal-messager.component.scss'],
  // tslint:disable-next-line: no-host-metadata-property
  host: { class: 'work-view no-back no-subtitle with-type-icon' }
})
export class ModalMessagerContentComponent implements OnInit {
  private modalMessage?: ModalMessage;
  private timer: InterruptableTimer;
  private displayMode?: ModalMessagerMode;
  private states: StatefulCSS;
  private isReusing = false;
  public fileExt = '.txt';
  public fileName = '';
  public fileAccept = '.txt';
  public file: any = null;
  @ViewChild('modalTitle', { static: true })
  modalTitle!: ElementRef<HTMLLabelElement>;
  @ViewChild('message', { static: true })
  message!: ElementRef<HTMLParagraphElement>;
  @ViewChild('barData', { static: true })
  barData!: ElementRef<HTMLDivElement>;
  @ViewChild('progressBar', { static: true })
  progressBar!: ElementRef<HTMLDivElement>;
  @ViewChild('buttonOne', { static: true })
  buttonOne!: ElementRef<HTMLButtonElement>;
  @ViewChild('buttonTwo', { static: true })
  buttonTwo!: ElementRef<HTMLButtonElement>;
  @ViewChild('requestExportUI', { static: true })
  requestExportUI!: ElementRef<HTMLDivElement>;
  @ViewChild('requestImportUI', { static: true })
  requestImportUI!: ElementRef<HTMLDivElement>;
  @ViewChild('downloadAnchor', { static: true })
  downloadAnchor!: ElementRef<HTMLAnchorElement>;
  // @ViewChild('importFileName', { static: true })
  // importFileName!: ElementRef;
  @ViewChild('exportFileName', { static: true })
  exportFileName!: ElementRef<HTMLInputElement>;
  @ViewChild('loginForm', { static: true })
  loginForm!: LoginFormComponent;

  constructor(private domNode: ElementRef, private server: ServerService, public modal: NgbActiveModal) {
    this.timer = new InterruptableTimer();
    this.states = new StatefulCSS(
      ['info', 'progress', 'progress-done', 'warn', 'confirm', 'request-export', 'request-import', 'login'],
      this.domNode.nativeElement,
      'modal-mode');
    this.states.SetState('info');
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event && event.key && event.key === 'escape') {
      event.preventDefault();
      if (event.cancelable) {
        event.stopImmediatePropagation();
      }
    }
    if (event && event.key && event.key.toLowerCase() === 'enter') {
      switch (this.states.GetCurrentState()) {
        case 'login':
          this.loginForm.Authenticate();
          break;
        case 'request-import':
          this.HandleCancel();
          break;
        case 'request-export':
          this.HandleCancel();
          break;
        case 'request-download':
          this.HandleCancel();
          break;
        case 'info':
          this.HandleOK();
          break;
        case 'progress':
          if ((this.modalMessage as ModalProgMsg).progress >= 1) {
            this.HandleOK();
            return;
          }
          if ((this.modalMessage as ModalProgMsg).cancelable) {
            this.HandleCancel('escaped');
          }
          break;
        case 'progress-done':
          this.HandleOK();
          return;
        case 'warn':
          this.HandleOK();
          break;
        case 'confirm':
          this.HandleButtonTwoClick();
          // this.HandleCancel('escaped');
          break;
      }
    }
  }
  Ok(title: string) {
    if (this.modalTitle.nativeElement.innerHTML === title) {
      this.HandleOK();
    }
  }
  Cancel(title: string, reason?: string) {
    if (this.modalTitle.nativeElement.innerHTML === title) {
      this.HandleCancel(reason);
    }
  }
  ngOnInit() {
    this.isReusing = this.isReusing;
    this.domNode.nativeElement.addEventListener('click', () => {
      this.ModalClicked();
    });
    this.buttonOne.nativeElement.addEventListener('click', () => { this.HandleButtonOneClick(); });
    this.buttonTwo.nativeElement.addEventListener('click', () => { this.HandleButtonTwoClick(); });
    this.loginForm.status.subscribe((info: ModalLoginInfo) => {
      const message: ModalLoginMessage = this.modalMessage as ModalLoginMessage;
      if (!!message.handler) {
        message.handler(info)
        this.HideModal();
      }
    });

  }

  SetTitle(title: string = '') {
    this.modalTitle.nativeElement.innerHTML = title;
    this.modalTitle.nativeElement.classList.toggle('hidden', title === '');

  }

  Confirm(message: ModalConfirmMsg) {
    this.states.SetState('confirm');
    this.domNode.nativeElement.classList.toggle('modal-warning', false);
    this.displayMode = ModalMessagerMode.CONFIRM;
    this.SetTitle(message.title);
    this.buttonOne.nativeElement.classList.toggle('hidden', false);
    this.buttonTwo.nativeElement.classList.toggle('hidden', false);
    this.barData.nativeElement.classList.toggle('hidden', true);

    this.buttonOne.nativeElement.innerHTML = 'Ok';
    this.buttonTwo.nativeElement.innerHTML = 'Cancel';

    this.message.nativeElement.innerHTML = message.message;

    this.modalMessage = message;
  }
  Notify(message: ModalNotice) {
    this.states.SetState('info');
    this.modalMessage = message;
    this.displayMode = ModalMessagerMode.NOTIFY;
    this.SetTitle(message.title);
    this.domNode.nativeElement.classList.toggle('modal-warning', message.asWarning);
    if (message.asWarning) {
      this.states.SetState('warn');
    }
    this.buttonOne.nativeElement.value = 'Close';
    this.buttonTwo.nativeElement.classList.toggle('hidden', true);
    this.message.nativeElement.innerHTML = message.message;
    let timeDelay = 1000;
    if ((message.message.length) / 0.015 > timeDelay) {
      timeDelay = (message.message.length) / 0.015;
    }
    this.HideProgress();
    this.timer.Start(this.HideModal.bind(this), timeDelay);

  }
  HideProgress(): void {
    this.progressBar.nativeElement.classList.toggle('hidden', true);
    this.barData.nativeElement.classList.toggle('hidden', true);

  }
  UnHideProgress(): void {
    this.progressBar.nativeElement.classList.toggle('hidden', false);
    this.barData.nativeElement.classList.toggle('hidden', false);
  }
  Progress(message: ModalProgMsg): void {

    this.displayMode = ModalMessagerMode.PROGRESS;
    this.domNode.nativeElement.classList.toggle('modal-warning', false);
    this.UnHideProgress();

    this.SetTitle(message.title);

    if (message.cancelable) {
      this.buttonOne.nativeElement.innerHTML = message.progress === 1 ? 'Close' : 'Cancel';
      this.buttonOne.nativeElement.classList.toggle('hidden', false);
      this.buttonTwo.nativeElement.classList.toggle('hidden', true);
    } else {
      message.cancelHandler = null;
      this.buttonOne.nativeElement.innerHTML = 'Ok';
      this.buttonOne.nativeElement.classList.toggle('hidden', message.progress < 1);
      this.buttonTwo.nativeElement.classList.toggle('hidden', true);
    }
    this.message.nativeElement.innerHTML = message.message;
    this.progressBar.nativeElement.style.width = '0%;';
    this.progressBar.nativeElement.innerHTML = '';

    this.modalMessage = message;

    if (!isNaN(message.progress)) {
      if (message.progress < 0) {
        message.progress = 0;
      }
      if (message.progress > 1) {
        message.progress = 1;
      }

      const percent = Math.floor(message.progress * 100.0);
      const newProgress = 'w-' + percent;
      this.barData.nativeElement.classList.toggle('hidden', false);
      // this.progressBar.nativeElement.classList.toggle(newProgress, true);
      this.progressBar.nativeElement.style.width = percent + '%';
      this.progressBar.nativeElement.innerHTML = percent + '%';
      if (percent === 100.0) {
        this.states.SetState('progress-done');
        this.progressBar.nativeElement.classList.toggle('progress-bar-striped', false);
        this.progressBar.nativeElement.classList.toggle('progress-bar-animated', false);
        let timeDelay = 2500;
        if ((message.message.length) / 0.015 > 2500) {
          timeDelay = (message.message.length) / 0.015;
        }
        if (!this.timer.wasRunning) {
          this.timer.Start(() => { this.HideModal(); }, timeDelay);
        }
      } else {
        this.states.SetState('progress');
        this.progressBar.nativeElement.classList.toggle('progress-bar-striped', true);
        this.progressBar.nativeElement.classList.toggle('progress-bar-animated', true);
        // $(this.buttonOne.nativeElement).toggleClass('hidden', true);
        // $(this.buttonTwo.nativeElement).toggleClass('hidden', true);
      }
    }
    this.isReusing = true;
  }
  RequestImport(message: ModalFileRequestMessage) {
    this.displayMode = ModalMessagerMode.REQ_IMPORT;
    this.states.SetState(this.displayMode);
    this.modalMessage = message;
    this.SetTitle(message.title);
    this.message.nativeElement.innerHTML = message.message;
    if (!!message.acceptedExts) {
      this.SanitizeExts(message.acceptedExts);
    }
    this.fileAccept = (!!message.acceptedExts) ? message.acceptedExts.join(',') : '';
    this.buttonOne.nativeElement.classList.toggle('hidden', true);
    this.buttonTwo.nativeElement.classList.toggle('hidden', false);

  }
  HandleFile(event: any) {
    if (!!event.target.files) {
      this.file = event.target.files[0];
    }
  }
  HandleImport() {
    const reader = new FileReader();
    reader.onload = (e) => {

      const contents = !!e.target ? e.target.result : '';
      if ((this.modalMessage as ModalFileRequestMessage).okHandler) {
        (this.modalMessage as ModalFileRequestMessage).okHandler({ file: this.file, contents: (contents) });
      }
      this.HideProgress();
      this.modal.close();

    };
    reader.onerror = (_e) => {
      this.HideProgress();
      if (!!(this.modalMessage as ModalFileRequestMessage).cancelHandler) {
        (this.modalMessage as ModalFileRequestMessage).cancelHandler({ reason: 'error', error: reader.error });
      }
    }
    reader.onabort = (_e) => {
      this.HideProgress();
      if (!!(this.modalMessage as ModalFileRequestMessage).cancelHandler) {
        (this.modalMessage as ModalFileRequestMessage).cancelHandler({ reason: 'aborted' });
      }
    }
    reader.onloadstart = () => {
      this.progressBar.nativeElement.style.width = '0%;';
      this.progressBar.nativeElement.innerHTML = 'loading ' + this.file.name + ' : 0%';
      this.UnHideProgress();
      // show progress bar
    }
    reader.onprogress = (event) => {

      const percent = this.file.size / event.loaded;
      this.progressBar.nativeElement.innerHTML = 'loading ' + this.file.name + ' : ' + percent + '%';
      this.UnHideProgress();
      // show progress amount
    }
    reader.onloadend = () => {
      const percent = 100;
      this.progressBar.nativeElement.innerHTML = 'loading ' + this.file.name + ' : ' + percent + '%';
    }
    let readType = (this.modalMessage as ModalFileRequestMessage).readType;
    const encoding = (this.modalMessage as ModalFileRequestMessage).encoding;
    if (!readType) {
      readType = 'text';
    }
    switch (readType) {
      case 'buffer':
        reader.readAsArrayBuffer(this.file);
        break;
      case 'string':
        reader.readAsBinaryString(this.file);
        break;
      case 'dataURL':
        reader.readAsArrayBuffer(this.file);
        break;
      case 'text':
        if (!!encoding) {
          reader.readAsText(this.file, encoding);
        } else {
          reader.readAsText(this.file);
        }
        break;
    }
  }
  RequestExport(message: ModalFileRequestMessage) {
    this.displayMode = ModalMessagerMode.REQ_EXPORT;
    this.states.SetState(this.displayMode);
    this.modalMessage = message;
    this.SetTitle(message.title);
    this.message.nativeElement.innerHTML = message.message;
    this.fileAccept = (!!message.acceptedExts) ? message.acceptedExts.join(',') : '';
    this.buttonOne.nativeElement.classList.toggle('hidden', true);
    this.buttonTwo.nativeElement.classList.toggle('hidden', false);
    this.exportFileName.nativeElement.value = (!!message.defaultFileName) ? message.defaultFileName : 'New File';
    if (!!message.acceptedExts) {
      this.SanitizeExts(message.acceptedExts);
    }
    this.fileExt = (!!message.acceptedExts) ? message.acceptedExts[0] : '.txt';
    if (!message.encoding) {
      message.encoding = 'text/plain';
    }
    this.downloadAnchor.nativeElement.href = this.MakeDataURL(message.encoding, message.contents)
    this.UpdateDownloadAnchor();
  }
  RequestDownload(message: ModalFileDownloadRequestMessage) {
    this.displayMode = ModalMessagerMode.REQ_EXPORT;
    this.states.SetState(this.displayMode);
    this.modalMessage = message;
    this.SetTitle(message.title);
    this.message.nativeElement.innerHTML = message.message;
    this.fileAccept = (!!message.acceptedExts) ? message.acceptedExts.join(',') : '';
    this.exportFileName.nativeElement.value = (!!message.defaultFileName) ? message.defaultFileName : 'New File';
    this.buttonOne.nativeElement.classList.toggle('hidden', true);
    this.buttonTwo.nativeElement.classList.toggle('hidden', false);
    if (!!message.acceptedExts) {
      this.SanitizeExts(message.acceptedExts);
    }
    this.fileExt = (!!message.acceptedExts) ? message.acceptedExts[0] : '.txt';
    this.downloadAnchor.nativeElement.classList.toggle('disabled', true);
    const fileName = !!message.defaultFileName ? message.defaultFileName : '';

    this.server.DownloadFile(message.serverURL, message.params, message.mimeType, fileName, (response: any) => {
      this.downloadAnchor.nativeElement.href = response.url;
      this.downloadAnchor.nativeElement.classList.toggle('disabled', false);
    });
    this.UpdateDownloadAnchor();


  }
  MakeDataURL(mimeType: string, payload: any): string {
    if (payload instanceof Blob) {
      return window.URL.createObjectURL(payload);
    }
    if (typeof payload !== 'string') {
      if (mimeType === 'application/json') {
        payload = JSON.stringify(payload);
        if (!payload) {
          // problem
          return '';
        }
      }
    }
    const blob1 = new Blob([payload], { type: mimeType });

    const url = window.URL.createObjectURL(blob1);
    return url;
  }
  UpdateFileName() {
    this.UpdateDownloadAnchor();
  }
  UpdateDownloadAnchor() {
    this.downloadAnchor.nativeElement.setAttribute('download', this.exportFileName.nativeElement.value + this.fileExt);
  }
  SanitizeExts(exts: Array<string>) {
    for (let i = 0, l = exts.length; i < l; i++) {
      if (exts[i][0] !== '.') {
        exts[i] = '.' + exts[i];
      }
    }
  }

  Login(message: ModalLoginMessage) {
    this.modalMessage = message;
    this.displayMode = ModalMessagerMode.LOGIN;
    this.states.SetState('login');
    this.SetTitle(message.title);
    this.message.nativeElement.innerText = message.message;
  }

  HandleOK(okHandler: SimpleHandler | DictHandler | null = null, optArgs: Dict | null = null) {
    if (okHandler !== null) {
      okHandler(optArgs ? optArgs : {});
    }
    this.HideModal('complete');
  }
  HandleCancel(why: string = 'cancelled') {
    this.HideModal(why);
  }

  HideModal(why: string = 'complete') {
    this.displayMode = ModalMessagerMode.UNKNOWN;
    this.timer.Stop();


    // $(this.domNode.nativeElement).parentsUntil('ngb-modal-window').prev('ngb-modal-backdrop').toggleClass('hidden', true);
    // $(this.domNode.nativeElement).parentsUntil('ngb-modal-window').fadeOut('medium');
    setTimeout(() => {
      if (why === 'complete') {

        this.modal.close();
      } else {
        this.modal.dismiss(why);
      }
    }, 100);
  }
  ModalClicked() {
    this.timer.Stop();
  }
  HandleButtonOneClick() {
    switch (this.displayMode) {
      case ModalMessagerMode.CONFIRM:
      case ModalMessagerMode.NOTIFY:
      case ModalMessagerMode.PROGRESS:
      case ModalMessagerMode.REQ_EXPORT:
      case ModalMessagerMode.REQ_IMPORT:
        const okHandler: SimpleHandler = (this.modalMessage as ModalConfirmMsg).okHandler as SimpleHandler;
        if (okHandler) {
          okHandler();
        }
        this.HideModal('complete');
        break;
      case ModalMessagerMode.LOGIN:
        this.loginForm.Authenticate();
        break;
    }
  }
  HandleButtonTwoClick() {
    let errHandler: DictHandler | null = null;
    switch (this.displayMode) {
      case ModalMessagerMode.CONFIRM:
        errHandler = (this.modalMessage as ModalConfirmMsg).cancelHandler as DictHandler;
        break;
      case ModalMessagerMode.NOTIFY:
      case ModalMessagerMode.PROGRESS:
        errHandler = (this.modalMessage as ModalProgMsg).cancelHandler as DictHandler;
        break;
      case ModalMessagerMode.UNKNOWN:


    }
    if (errHandler) {
      errHandler({ reason: 'cancelled' });
    }
    this.HideModal('cancel');
  }
  ExportClicked() {
    const message: ModalFileRequestMessage = this.modalMessage as ModalFileRequestMessage;
    if (message.okHandler) {
      message.okHandler(message);
    }
    this.modal.close();

  }

}

@Component({
  selector: 'app-modal-messager',
  template: ''
})
export class ModalMessagerComponent implements OnDestroy {
  modalRef?: NgbModalRef;
  subscriptionMgr: SubscriptionMgr;
  lastTitle: string | null = null;

  constructor(private modalService: NgbModal, private messagerService: ModalMessagerService) {

    this.subscriptionMgr = new SubscriptionMgr();
    this.subscriptionMgr.Subscribe(messagerService.remoteCtrl$, (message: ModaLRemoteCtrlMessage) => {
      if (!!this.modalRef) {
        if (!!this.modalRef.componentInstance) {
          switch (message.cmd) {
            case 'ok':
              this.modalRef.componentInstance.Ok(message.title);
              break;
            case 'cancel':
              this.modalRef.componentInstance.Cancel(message.title, message.message);
          }

        }
      }
    });
    this.subscriptionMgr.Subscribe(messagerService.confirm$, (message: ModalConfirmMsg) => {
      this.modalRef = this.modalService.open(ModalMessagerContentComponent, { backdrop: 'static',keyboard:false });
      this.modalRef.componentInstance.Confirm(message);
      this.lastTitle = null;
    });
    this.subscriptionMgr.Subscribe(messagerService.notify$, (message: ModalNotice) => {
      this.modalRef = this.modalService.open(ModalMessagerContentComponent, { backdrop: 'static',keyboard:false });
      this.modalRef.componentInstance.Notify(message);
      this.lastTitle = null;
    });
    this.subscriptionMgr.Subscribe(messagerService.cancellation$, (message: any) => {
      if (this.lastTitle === message.title) {
        if (this.modalRef) {
          this.modalRef.componentInstance.HandleCancel();
        }
        this.lastTitle = null;
      }
      this.lastTitle = null;
    });
    this.subscriptionMgr.Subscribe(messagerService.progress$, (message: ModalProgMsg) => {
      if ((this.lastTitle === message.title) && this.lastTitle != null) {
        if (this.modalRef === null) {
          return;
        }
        try {
          if (this.modalRef) {
            this.modalRef.componentInstance.Progress(message);
          }
          if (message.progress >= 1) {
            this.lastTitle = null;
          }
          return;
        } catch (e) {
          this.modalRef = undefined;
          this.lastTitle = null;
          this.messagerService.CancelProgress(message.title);

        }
        return;
      }
      this.lastTitle = message.title;

      this.modalRef = this.modalService.open(ModalMessagerContentComponent, { backdrop: 'static',keyboard:false });
      this.modalRef.componentInstance.Progress(message);
    });
    this.subscriptionMgr.Subscribe(messagerService.importRequest$, (message: ModalFileRequestMessage) => {
      this.modalRef = this.modalService.open(ModalMessagerContentComponent, { backdrop: 'static',keyboard:false });
      this.modalRef.componentInstance.RequestImport(message);
    });
    this.subscriptionMgr.Subscribe(messagerService.exportRequest$, (message: ModalFileRequestMessage) => {
      this.modalRef = this.modalService.open(ModalMessagerContentComponent, { backdrop: 'static',keyboard:false });
      this.modalRef.componentInstance.RequestExport(message);
    });
    this.subscriptionMgr.Subscribe(messagerService.downloadRequest$, (message: ModalFileDownloadRequestMessage) => {
      this.modalRef = this.modalService.open(ModalMessagerContentComponent, { backdrop: 'static',keyboard:false });
      this.modalRef.componentInstance.RequestDownload(message);
    });
    this.subscriptionMgr.Subscribe(messagerService.login$, (message: ModalLoginMessage) => {
      this.modalRef = this.modalService.open(ModalMessagerContentComponent, { backdrop: 'static',keyboard:false })
      this.modalRef.componentInstance.Login(message);
    });
  }

  ngOnDestroy() {
    this.subscriptionMgr.CancelSubscriptions();

  }


}
